import React from 'react';
import styles from './NotFound.module.css'

const NotFound = () => {
    return ( <div className={styles.empty}>Sin resultados</div> );
}
 
export default NotFound;